import { render, staticRenderFns } from "./Columns.vue?vue&type=template&id=02f95534"
import script from "./Columns.vue?vue&type=script&lang=ts"
export * from "./Columns.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02f95534')) {
      api.createRecord('02f95534', component.options)
    } else {
      api.reload('02f95534', component.options)
    }
    module.hot.accept("./Columns.vue?vue&type=template&id=02f95534", function () {
      api.rerender('02f95534', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reportengine/Columns.vue"
export default component.exports